// extracted by mini-css-extract-plugin
export default {"root":"_18yoa","heading-and-subheading-block":"_2xU-t","headingAndSubheadingBlock":"_2xU-t","subheading":"ZcrR2"};